import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import React, { useState, useMemo, useCallback } from 'react';
import styled from 'styled-components';
import { breakpoint, color, fontSize } from '@core-ds/primitives';
import SelectableProductList from './selectable_product_list.js';
import ProductImageGrid from './product_image_grid.js';
import { _js } from '@ifixit/localize';
var ABOVE_MOBILE = "@media screen and (min-width: ".concat(breakpoint.md, ")");
/* styled page elements */

var RecommendedProducts = styled.section(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   max-width: 1024px;\n\n   ", " {\n      padding: 20px 0;\n      display: flex;\n      justify-content: space-evenly;\n   }\n"])), ABOVE_MOBILE);
var Details = styled.section(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   margin: 20px 5px;\n   line-height: 1.5;\n   display: flex;\n   flex-direction: column;\n   justify-content: center;\n\n   ", " {\n      flex-shrink: 0;\n      max-width: 50%;\n      margin: 10px 0px 10px 20px;\n   }\n"])), ABOVE_MOBILE);
var StyledProductImageGrid = styled(ProductImageGrid)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   margin: 0 10px;\n\n   ", " {\n      flex-shrink: 0;\n      margin: 10px 0;\n   }\n"])), ABOVE_MOBILE);
var Price = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n   color: ", ";\n   padding: 0 5px;\n   font-size: ", ";\n"])), function (props) {
  return props.isSelected ? color.red[600] : color.gray[500];
}, fontSize.md);
var Wrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n   position: relative;\n   display: flex;\n   width: 100%;\n   padding: 10px 0;\n\n   ", " {\n      color: ", ";\n      font-weight: bold;\n      font-size: ", ";\n      margin-right: 24px;\n   }\n"])), Price, color.red[600], fontSize['3xl']);
var Submit = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n   background: ", ";\n   font-family: inherit;\n   color: white;\n   font-size: ", ";\n   padding: 10px 15px;\n   font-weight: bold;\n   border-radius: 5px;\n   border: none;\n   cursor: pointer;\n\n   &:disabled {\n      background: ", ";\n   }\n"])), color.blue.ifixit, fontSize.md, color.gray[300]);

function formatPriceUS(price) {
  return price.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function RecommendedProductsComponent(_ref) {
  var addToCart = _ref.addToCart,
      initialProduct = _ref.initialProduct,
      relatedProducts = _ref.relatedProducts,
      _ref$formatPrice = _ref.formatPrice,
      formatPrice = _ref$formatPrice === void 0 ? formatPriceUS : _ref$formatPrice;
  var related = useMemo(function () {
    return [initialProduct].concat(_toConsumableArray(relatedProducts.slice(0, 2)));
  }, [initialProduct, relatedProducts]);

  var _useState = useState(function () {
    return new Set();
  }),
      _useState2 = _slicedToArray(_useState, 2),
      unselected = _useState2[0],
      setUnselected = _useState2[1];

  var isSelected = useCallback(function (product) {
    return !unselected.has(product.sku);
  }, [unselected]);
  var getSelected = useCallback(function () {
    return related.filter(isSelected);
  }, [related, isSelected]);
  var getTotal = useCallback(function () {
    return formatPrice(getSelected().reduce(function (a, b) {
      return a + b.price;
    }, 0));
  }, [getSelected, formatPrice]);
  var onSelectedChange = useCallback(function (sku, checked) {
    setUnselected(function (oldUnselected) {
      var unselected = new Set(oldUnselected);

      if (checked) {
        unselected.delete(sku);
      } else {
        unselected.add(sku);
      }

      return unselected;
    });
  }, [setUnselected]);
  var fireAddToCart = useCallback(function () {
    addToCart(getSelected());
  }, [addToCart, getSelected]);
  return /*#__PURE__*/React.createElement(RecommendedProducts, {
    className: "recommended-products"
  }, /*#__PURE__*/React.createElement(StyledProductImageGrid, {
    initialProduct: initialProduct,
    relatedProducts: related,
    isSelected: isSelected
  }), /*#__PURE__*/React.createElement(Details, null, /*#__PURE__*/React.createElement(SelectableProductList, {
    initialProduct: initialProduct,
    relatedProducts: related,
    isSelected: isSelected,
    onSelectedChange: onSelectedChange,
    formatPrice: formatPrice
  }), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Price, {
    className: "total"
  }, getTotal()), /*#__PURE__*/React.createElement(Submit, {
    onClick: fireAddToCart,
    disabled: getSelected().length === 0
  }, _js('Add to cart')))));
}

export default RecommendedProductsComponent;